import { render } from "./FileManagerLibrary.vue?vue&type=template&id=3c4f67b7&scoped=true"
import script from "./FileManagerLibrary.vue?vue&type=script&lang=js"
export * from "./FileManagerLibrary.vue?vue&type=script&lang=js"

import "./FileManagerLibrary.vue?vue&type=style&index=0&id=3c4f67b7&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c4f67b7"]])

export default __exports__